var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3553 0.465515L30.0884 8.59219L9.03502 8.72959L10.4064 26.052L27.4111 24.6411L27.981 33.1835L11.113 33.046L12.2856 49.7821L31.733 49.1285L32 54.7753L1.03897 55.4655L0 1.46418L30.3587 0.465515H30.3553Z",
    fill: "#FFCC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/e.c555fc0634ac7348c6301d5823185650.svg";
export { ForwardRef as ReactComponent };